<div class="portal_payment_main" [ngClass]="allowedToPay ? 'portal_payment_main' : 'portal_payment_main payment-disable'">
    <div class="t-center"><strong>Amount To Pay</strong></div>
    <div class="">
      <h2 *ngIf="!showPayInput" class="t-center font-roboto">
        <strong>
          <!-- {{ invoice?.Item?.RemainingBalance || 0 | formatNumber }} -->
          {{
            (isACHPayment ? AchPaymentTotal : PaymentTotal) | formatNumber
            }}
        </strong>
      </h2>
      <h2 class="t-center mb-0" *ngIf="showPayInput">
  <!--      <input class="lg-input" placeholder="$0.00" [(ngModel)]="payAlias" (ngModelChange)="getChnagedValue()" />-->
        <p-inputNumber
          #payAliasInput
          [maxFractionDigits]="2"
          [maxlength]="13"
          [minFractionDigits]="2"
          [min]="0"
          [max]="invoice?.Item?.RemainingValue || 0"
          [(ngModel)]="payAlias"
          (ngModelChange)="getChnagedValue(payAliasInput)"
          [step]="0"
          currency="USD"
          inputStyleClass="lg-input font-roboto"
          mode="currency"
          placeholder="$0.00" type="text" [disabled]="paymentprocessing || paymentsuccessful || paymentfailed">
        </p-inputNumber>
      </h2>
    </div>
    <div class="f-row f-center" style="margin-bottom: 1rem">
      <button *ngIf="!showPayInput && !(paymentprocessing || paymentsuccessful || paymentfailed)" [disabled]="paymentprocessing || paymentsuccessful || paymentfailed" (click)="partialPayment('partial')"
        class="payment-type-buttons tiny round no-border no-transform" style="opacity: 1">
        <span>Make partial payment</span>
      </button>
      <div *ngIf="showPayInput" class="d-flex align-items-center justify-content-between w-100 px-1">
        <small class="text-muted"><span class="font-roboto">{{ remainingValue || 0 | formatNumber }}</span> remaining</small>
        <button *ngIf="!(paymentprocessing || paymentsuccessful || paymentfailed)" [disabled]="paymentprocessing || paymentsuccessful || paymentfailed" class="payment-type-buttons tiny round no-border no-transform" (click)="partialPayment('full')">
          Pay in full
        </button>
      </div>
    </div>
  
    <div *ngIf="invoice.Item.AcceptCreditCard && invoice.Item.AcceptACH" class="payment-type-buttons d-flex flex-wrap">
      <ng-container *ngIf="invoice.Item.AcceptCreditCard">
        <label [appLogEvent] (click)="ccPayment()" [class]="
            isACHPayment
              ? 'no-border no-transform round button'
              : 'no-border no-transform round button active'
          ">
          <!-- <i class="i-credit-card"></i> -->
          <span>Pay with credit card</span>
        </label>
      </ng-container>
      <ng-container *ngIf="invoice.Item.AcceptACH">
        <label [appLogEvent] (click)="ACHPayment()" [class]="
            !isACHPayment
              ? 'no-border no-transform round button'
              : 'no-border no-transform round button active'
          ">
          <!-- <i class="i-landmark"></i> -->
          <span>Pay with ACH</span>
        </label>
      </ng-container>
    </div>
    <h5 *ngIf="!isACHPayment" class="f-row f-a-start font-weight-bold">
      <strong>Credit Card Payment</strong>
    </h5>
    <h5 *ngIf="isACHPayment"  class="f-row f-a-start font-weight-bold">
      <strong>ACH Payment</strong>
    </h5>
  
    <div class="autoslider f-column" style="margin: 2rem 0px 0px">
      <div class="payment-slider" [style.height]="containerHeight">
        <!-- When Pay with Credit Card -->
        <div [class]="!isACHPayment ? 'slide show' : 'slide'">
          <div [ngClass]="
              paymentprocessing || paymentsuccessful || paymentfailed
                ? 'slide'
                : 'slide show'
            ">
            <div id="submit">
              <div class="payment-amounts">
                <div class="payment-amount">
                  <div class="payment-label">Payment Amount</div>
                  <div class="payment-value font-roboto">
                    <span>{{
                      (invoice.Item.CreditCardFee === paymentFee.Customer
                      ? withOutFeeTotal
                      : PaymentTotal
                      ) | formatNumber
                      }}</span>
                  </div>
                </div>
                <ng-container *ngIf="invoice.Item.CreditCardFee === paymentFee.Customer">
                  <div class="payment-amount">
                    <div class="payment-label f-row">
                      <span style="margin-right: 0.25rem; margin-top: 2px">Processing Fee</span>
                      <div class="f-nogrow d-inline-block" style="position: relative">
                        <button
                          [popover]="approvall" #pop="bs-popover" placement="bottom" [adaptivePosition]="true" [outsideClick]="true"
                          containerClass="main-general-dropdown" container="body"
                          class="tiny icon-button round transparent no-border bg-transparent"
                          tooltip="Setting Explanation">
                          <i class="i-help m-0"></i>
                        </button>
                        <ng-template #approvall>
                          <button class="tiny no-border round" style="float: right;">
                            <i class="i-cross m-0" (click)="pop.hide()"></i>
                          </button>
                          <strong>Processing Fees</strong>
                          <div class="info-content">
                            <p>
                              Processing fee for each Credit Card transaction is {{processingFee.CC.Value}}%.
                              <br />
                              Processing fee for each ACH transaction is {{processingFee.ACH.Value}}% min ${{processingFee.ACH.Min}} max ${{processingFee.ACH.Max}}.
                            </p>
                            <p>
                              Other fees may apply, as applicable:
                              <br />
                              $15.00 per chargeback (in addition to the amount of the chargeback).
                              <br />
                              $15.00 per ACH return (in addition to the amount of the return).
                              <br />
                              $25.00 research fee if an account is deemed abandoned.
                            </p>
                            <p>
                          <strong>Refunds</strong><br>
                         Refunds will be issued to the original payment method, less any applicable 
                         transaction or processing fees. Payment processor fees are 
                         non-refundable and will not be returned as part of the refund.
                        </p>
                            <!-- <div class="mt-4">
                              <strong>Required regulatory disclosure of fees in Canada:</strong>
                            </div>
                           <table>
                            <thead>
                              <tr>
                                <th>
                                  Payment Card Type
                                  <br />
                                  <p style="font-weight: 'normal'; padding-right: '3rem'">
                                    <small>
                                      These are the most common domestically issued card
                                      types and processing methods. They do not represent
                                      all the possible fees and variations that are charged
                                      to the merchants.
                                    </small>
                                  </p>
                                </th>
                                <th>
                                  Processing Method <br />
                                  (Card Not Present)
                                  <br />
                                  <p style="font-weight: 'normal'">
                                    <small>
                                      Means that the card/device was not electronically
                                      read. Generally, the card information is manually
                                      key-entered, e.g. online payment)
                                    </small>
                                  </p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>American Express Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>American Express Prepaid Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>MasterCard Business Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>MasterCard Core Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>MasterCard Corporate Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>MasterCard Debit Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>MasterCard Prepaid Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>MasterCard World Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>MasterCard World Elite Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Visa Business Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Visa Infinite Business Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Visa Consumer Credit Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Visa Corporate Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Visa Debit Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Visa Infinite Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Visa Infinite Privilege Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Visa Prepaid Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                              <tr>
                                <td>Discover Cards</td>
                                <td>{{processingFee.CC.Value}}%</td>
                              </tr>
                            </tbody>
                            <thead>
                              <tr>
                                <th>Other Fees</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Chargebacks</td>
                                <td>$15.00 CAD</td>
                              </tr>
                            </tbody>
                          </table> -->
                          </div>
                        </ng-template>
                      </div>
                    </div>
                    <div class="payment-value font-roboto" style="margin-top: 2px">
                      <span>{{ cardProcessingFee | formatNumber }}</span>
                    </div>
                  </div>
                  <div class="payment-amount">
                    <div class="payment-label">
                      <strong>Payment Total</strong>
                    </div>
                    <div class="payment-value font-roboto">
                      <strong>{{ PaymentTotal | formatNumber }}</strong>
                    </div>
                  </div>
                </ng-container>
              </div>
              <span>
                <div class="container">
                  <div class="f-row f-a-center f-wrap">
                    <img id="accepted-cards" src="../../../assets/img/card-brands.a87510a2.png" alt="Accepted Cards" />
                    <span class="f-grow"></span>
                  </div>
                  <form [formGroup]="form">
                    <div class="d-flex gap-3 mb-3" style="padding-right: 2px;">
                      <div class="w-100 position-relative">
                        <label><small>Name on card</small></label>
                        <div>
                          <input required="" type="text" maxlength="25" name="name-on-card" formControlName="Name"
                            id="name-on-card" class="w-100" value="" [ngClass]="{
                              'is-invalid':
                                f['Name'].invalid &&
                                (f['Name'].dirty || f['Name'].touched)
                            }" />
                        </div>
                        <div class="paym-form-error" id="error-cc-postal" *ngIf="
                            f['Name'].invalid &&
                            (f['Name'].dirty || f['Name'].touched)
                          ">
                          <span class="error-text"><span class="error-icon">!</span>Full name is
                            required</span>
                        </div>
                      </div>
                      <div class="w-100 position-relative">
                        <label><small>Email for receipt</small></label>
                        <input type="email" name="email" id="email-for-receipt" formControlName="Email" class="w-100"
                          [ngClass]="{
                            'is-invalid':
                              f['Email'].invalid &&
                              (f['Email'].dirty || f['Email'].touched)
                          }" />
                        <div class="paym-form-error" id="error-cc-email" *ngIf="
                            f['Email'].invalid &&
                            (f['Email'].dirty || f['Email'].touched)
                          ">
                          <span class="error-text" *ngIf="f['Email'].errors?.['required']">
                            <span class="error-icon">!</span>Email is
                            required</span>
                          <span class="error-text" *ngIf="f['Email'].errors?.['pattern']">
                            <span class="error-icon">!</span>A valid email is
                            required</span>
                        </div>
                      </div>
                    </div>
                    <div class="payment-iframe">
                      <div className="row">
                        <justifi-card-form></justifi-card-form>
                      </div>
                    </div>
                    <div class="postal-code mb-4 position-relative">
                      <label><small>Postal code</small></label>
                      <input type="text" name="postal-code" id="postal-code" class="" value=""
                        formControlName="PostalCode" [ngClass]="{
                          'is-invalid':
                            f['PostalCode'].invalid &&
                            (f['PostalCode'].dirty || f['PostalCode'].touched)
                        }" />
                      <div class="paym-form-error" id="error-cc-postal" *ngIf="
                          f['PostalCode'].invalid &&
                          (f['PostalCode'].dirty || f['PostalCode'].touched)
                        ">
                        <span class="error-text" *ngIf="f['PostalCode'].errors?.['required']"><span
                            class="error-icon">!</span>Postal code is
                          required</span>
                        <span class="error-text" *ngIf="f['PostalCode'].errors?.['pattern']"><span
                            class="error-icon">!</span>A valid postal code is
                          required</span>
                      </div>
                    </div>
  
                    <div class="f-column">
                      <button preventMultipleCalls [appLogEvent] [disabled]="settings.ViewJustiFiIntegrationForDemo || (showPayInput && !(payAlias > 0))" class="call-to-action big no-transform justify-content-center rounded-pill"
                        (click)="payNowAmount()" name="action" id="submit-credit-card-button">
                        <span><i class="i-lock m-0"></i> Pay Now</span>
                      </button>
                    </div>
                  </form>
                </div>
              </span>
            </div>
          </div>
        </div>
  
        <div [ngClass]="paymentprocessing ? 'slide show' : 'slide'">
          <div class="f-column">
            <div class="f-column f-a-center" style="margin-bottom: 4rem">
              <span class="small-spinner"></span>
              <h4 style="margin-top: 1rem">Submitting Payment...</h4>
            </div>
          </div>
        </div>
  
        <div [ngClass]="paymentsuccessful ? 'slide show' : 'slide'">
          <div class="f-column">
            <div class="f-column f-a-center" style="margin: 1rem 0px 4rem">
              <i class="i-check-circle success" style="font-size: 4rem"></i>
              <h4 style="margin-top: 2rem">Payment Submitted</h4>
              <button (click)="paymentSubmitted()" class="tiny round no-transform no-border">
                <span>back</span>
              </button>
            </div>
          </div>
        </div>
  
        <div [ngClass]="paymentfailed ? 'slide show' : 'slide'">
          <div class="f-column">
            <div class="f-column f-a-center" style="margin: 1rem 0px 4rem">
              <i class="i-exclamation-circle" style="font-size: 4rem"></i>
              <h4 style="margin-top: 2rem">Payment failed to submit</h4>
              <div class="danger">{{ message }}</div>
              <button (click)="previous()" *ngIf="!isInvoiceChanged" class="tiny round no-transform no-border">
                <span>back</span>
              </button>
              <button (click)="refresh()" *ngIf="isInvoiceChanged" class="tiny round no-transform no-border">
                <span>back</span>
              </button>
            </div>
          </div>
        </div>
  
        <!-- When Pay with ACH -->
        <div [class]="isACHPayment ? 'slide show' : 'slide'">
          <div [ngClass]="
              paymentprocessing || paymentsuccessful || paymentfailed
                ? 'slide f-column'
                : 'slide f-column show'
            ">
            <div class="payment-amounts">
              <div class="payment-amount">
                <div class="payment-label">Payment Amount</div>
                <div class="payment-value font-roboto">
                  <span>{{
                    (invoice.Item.AchFee === paymentFee.Customer
                    ? withOutFeeTotal
                    : AchPaymentTotal
                    ) | formatNumber
                    }}</span>
                </div>
              </div>
              <ng-container *ngIf="invoice.Item.AchFee === paymentFee.Customer">
                <div class="payment-amount" #rApproval>
                  <div class="payment-label f-row">
                    <span style="margin-right: 0.25rem; margin-top: 2px">Processing Fee</span>
                      <button (onHidden)="onPopoverHidden(rApproval)" (onShown)="onPopoverShown(rApproval)"
                        [popover]="approval" #pop="bs-popover" placement="bottom" [adaptivePosition]="true" [outsideClick]="true"
                        containerClass="main-general-dropdown" container="body"
                        class="tiny icon-button round transparent no-border bg-transparent"
                        tooltip="Setting Explanation">
                        <i class="i-help m-0"></i>
                      </button>
                    <ng-template #approval>
                      <button class="tiny no-border round" style="float: right;">
                        <i class="i-cross m-0" (click)="pop.hide()"></i>
                      </button>
                      <strong>Processing Fees</strong>
                      <div class="info-content">
                        <p>
                          Processing fee for each Credit Card transaction is {{processingFee.CC.Value}}%.
                          <br />
                          Processing fee for each ACH transaction is {{processingFee.ACH.Value}}% min ${{processingFee.ACH.Min}} max ${{processingFee.ACH.Max}}.
                        </p>
                        <p>
                          Other fees may apply, as applicable:
                          <br />
                          $15.00 per chargeback (in addition to the amount of the chargeback).
                          <br />
                          $15.00 per ACH return (in addition to the amount of the return).
                          <br />
                          $25.00 research fee if an account is deemed abandoned.
                        </p>
                        <p>
                          <strong>Refunds</strong><br>
                         Refunds will be issued to the original payment method, less any applicable 
                         transaction or processing fees. Payment processor fees are 
                         non-refundable and will not be returned as part of the refund.
                        </p>
                        <!-- <div class="mt-4">
                          <strong >Required regulatory disclosure of fees in Canada:</strong>
                        </div>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              Payment Card Type
                              <br />
                              <p style="font-weight: 'normal'; padding-right: '3rem'">
                                <small>
                                  These are the most common domestically issued card
                                  types and processing methods. They do not represent
                                  all the possible fees and variations that are charged
                                  to the merchants.
                                </small>
                              </p>
                            </th>
                            <th>
                              Processing Method <br />
                              (Card Not Present)
                              <br />
                              <p style="font-weight: 'normal'">
                                <small>
                                  Means that the card/device was not electronically
                                  read. Generally, the card information is manually
                                  key-entered, e.g. online payment)
                                </small>
                              </p>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>American Express Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>American Express Prepaid Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>MasterCard Business Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>MasterCard Core Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>MasterCard Corporate Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>MasterCard Debit Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>MasterCard Prepaid Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>MasterCard World Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>MasterCard World Elite Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Visa Business Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Visa Infinite Business Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Visa Consumer Credit Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Visa Corporate Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Visa Debit Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Visa Infinite Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Visa Infinite Privilege Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Visa Prepaid Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                          <tr>
                            <td>Discover Cards</td>
                            <td>{{processingFee.CC.Value}}%</td>
                          </tr>
                        </tbody>
                        <thead>
                          <tr>
                            <th>Other Fees</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Chargebacks</td>
                            <td>$15.00 CAD</td>
                          </tr>
                        </tbody>
                      </table> -->
                    </div>
                    </ng-template>
                  </div>
                  <div class="payment-value font-roboto" style="margin-top: 2px">
                    <span>{{ achProcessingFee | formatNumber }}</span>
                  </div>
                </div>
  
                <div class="payment-amount">
                  <div class="payment-label"><strong>Payment Total</strong></div>
                  <div class="payment-value font-roboto">
                    <strong>{{ AchPaymentTotal | formatNumber }}</strong>
                  </div>
                </div>
              </ng-container>
            </div>
          <form [formGroup]="achForm">
              <div>
                <div class="d-flex gap-3 mb-3" style="padding-right: 2px;">
                  <div class="w-100 position-relative ">
                    <label><small>Name</small></label>
                    <div>
                      <input required="" type="text" maxlength="25" name="name-on-card-ach" formControlName="Name"
                        id="name-on-card-ach" class="w-100" value="" [ngClass]="{
                          'is-invalid':
                          fAch['Name'].invalid &&
                            (fAch['Name'].dirty || fAch['Name'].touched)
                        }" />
                    </div>
                    <div class="paym-form-error" id="error-ach-name" *ngIf="
                    fAch['Name'].invalid &&
                        (fAch['Name'].dirty || fAch['Name'].touched)
                      ">
                      <span class="error-text"><span class="error-icon">!</span>Full name is
                        required</span>
                    </div>
                  </div>
                  <div class="w-100 position-relative">
                    <label><small>Email for receipt</small></label>
                    <input type="email" name="email" id="email-for-receipt" formControlName="Email" class="w-100"
                      [ngClass]="{
                        'is-invalid':
                        fAch['Email'].invalid &&
                          (fAch['Email'].dirty || fAch['Email'].touched)
                      }" />
                    <div class="paym-form-error" id="error-ach-email" *ngIf="
                    fAch['Email'].invalid &&
                        (fAch['Email'].dirty || fAch['Email'].touched)
                      ">
                      <span class="error-text" *ngIf="fAch['Email'].errors?.['required']">
                        <span class="error-icon">!</span>Email is
                        required</span>
                      <span class="error-text" *ngIf="fAch['Email'].errors?.['pattern']">
                        <span class="error-icon">!</span>A valid email is
                        required</span>
                    </div>
                  </div>
                </div>
                <div class="payment-iframe mb-3">
                  <div className="row">
                    <justifi-bank-account-form></justifi-bank-account-form>
                  </div>
                </div>
                <div class="f-column">
                  <button preventMultipleCalls [appLogEvent] [disabled]="settings.ViewJustiFiIntegrationForDemo  || (showPayInput && !(payAlias > 0))" class="call-to-action big no-transform justify-content-center rounded-pill"
                    (click)="payNowByJustiFiBankAccount()" name="action">
                    <span><i class="i-lock m-0"></i> Pay Now</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <div class="f-row f-center">
        <div id="powered-by-JustiFi" class="powered-by-justifi text-center mt-3">
          <p class="mb-2">
            Powered by
            <img class="ml-2" style="width: 42px; margin-top: -4px;" id="justifi-logo" src="../../../assets/JustiFi/justifi-logo.png" alt="JustiFi" />
          </p>
          <p class="shield mb-2">
            <img id="secure-shield" width="20" src="../../../assets//img/secure-icon.PNG" alt="Shield" />
            Secure 256 bit encryption
          </p>
        </div>
      </div>
    </div>
  
    <div class="enable-payment-wrapper" *ngIf="!allowedToPay">
      <div class="content">
        <p>Payment processing will be enabled once the invoice has been finalized.</p>
      </div>
    </div>
  
  </div>
  